import { ErrorBoundary } from "../../../ErrorBoundary";
import { TimeseriesProps } from "../Timeseries.types";
import { Bars } from "./Bars";
import { Regular } from "./Regular";

export const LegacyTimeseries = <K extends string, T extends string>(
  props: TimeseriesProps<K, T>,
) => {
  const variant = props.variant ?? "lines";
  const Component = variant === "lines" ? Regular : Bars;

  return (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );
};
